import React from 'react';
import { useCompanies } from '@/core/api/queries/companies';
import { useUsers } from '@/core/api/queries/users';
import { Building, Users } from 'lucide-react';
import { User } from '../types';
import { useCarriers } from '@/core/api/queries/carriers';
import { Company } from '../types';

export const Tabs: React.FC<{
  activeTab: 'companies' | 'users' | 'carrier-integrations';
  setActiveTab: (tab: 'companies' | 'users' | 'carrier-integrations') => void;
}> = ({ activeTab, setActiveTab }) => {
  const companies = useCompanies();
  const companiesData = (companies.data as Company[]) || [];

  const users = useUsers();
  const usersData = (users.data as User[]) || [];

  const carriers = useCarriers();
  const lspCompaniesData = companiesData.filter((company) => company.role === 'LSP');

  return (
    <div className="border-b border-gray-200">
      <nav className="flex">
        <button
          onClick={() => setActiveTab('companies')}
          className={`px-6 py-4 text-sm font-medium border-b-2 ${
            activeTab === 'companies'
              ? 'border-blue-500 text-blue-600 bg-blue-50'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
          }`}
        >
          <div className="flex items-center space-x-2">
            <Building size={16} />
            <span>Companies ({lspCompaniesData.length})</span>
          </div>
        </button>
        <button
          onClick={() => setActiveTab('users')}
          className={`px-6 py-4 text-sm font-medium border-b-2 ${
            activeTab === 'users'
              ? 'border-blue-500 text-blue-600 bg-blue-50'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
          }`}
        >
          <div className="flex items-center space-x-2">
            <Users size={16} />
            <span>Users ({usersData.length})</span>
          </div>
        </button>
        <button
          onClick={() => setActiveTab('carrier-integrations')}
          className={`px-6 py-4 text-sm font-medium border-b-2 ${
            activeTab === 'carrier-integrations'
              ? 'border-blue-500 text-blue-600 bg-blue-50'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
          }`}
        >
          <div className="flex items-center space-x-2">
            <Users size={16} />
            <span>Carrier integrations {carriers.data?.length}</span>
          </div>
        </button>
      </nav>
    </div>
  );
};
